import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col items-center justify-center h-full text-center ">
      <div className="w-48 lg:w-72 flex items-center justify-center">
        <svg
          width="100%"
          height="100%"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 575 581"
          className="overflow-visible"
        >
          <g fill="url(#gradient)">
            <g id="letter-n">
              <path d="M49.633 449.889c-26.83-40.194-94.224-166.974-1.284-318.286 2.298-3.75 7.974-3.058 9.326 1.149l33.283 102.992c1.808 5.609 10.103 4.309 10.103-1.588V73.569a5.17 5.17 0 0 1 2.366-4.342l50.87-32.81c3.447-2.213 7.975.253 7.975 4.342v499.045c0 3.919-4.19 6.42-7.637 4.545l-34.854-18.923a5.114 5.114 0 0 1-2.484-3.041L68.15 360.497c-1.74-5.727-10.205-4.426-10.12 1.571l1.098 84.881c.067 5.153-6.606 7.231-9.461 2.956l-.034-.016Z" />
            </g>

            <g id="letter-o">
              <path d="M369.928 15.13C284.676-11.26 227.841 4.67 205.253 13.98c-6.674 2.737-10.982 9.276-10.982 16.49v518.829a17.901 17.901 0 0 0 12.114 16.929c78.274 26.846 140.042 9.917 164.608.557a17.884 17.884 0 0 0 11.522-16.709V32.21c0-7.84-5.102-14.766-12.587-17.08Zm-41.865 481.169c0 5.896-1.943 11.168-4.866 13.28-10.357 7.433-36.375 20.865-69.354-.44-3.058-1.976-5.102-7.366-5.102-13.448v-411.9c0-5.728 1.807-10.915 4.612-13.094 9.529-7.383 33.469-20.038 69.405.912 3.142 1.842 5.305 7.35 5.305 13.567v411.123Z" />
            </g>

            <g id="letter-b">
              <path d="M573.006 323.277l-28.046-29.684a7.264 7.264 0 0 1 .305-10.272l27.234-25.63a7.224 7.224 0 0 0 2.264-5.981c-2.179-22.082-19.513-140.854-144.047-213.063-4.832-2.821-10.914.676-10.914 6.268v491.206c0 5.643 6.133 9.123 10.965 6.234 33.908-20.223 135.278-90.591 144.216-213.587a7.183 7.183 0 0 0-1.977-5.491Zm-60.264 28.739-26.323 54.638c-1.943 4.038-8.008 2.653-8.008-1.824v-53.524c0-1.115.439-2.179 1.233-2.973l14.8-14.851a4.2 4.2 0 0 1 6.201.253l11.539 13.753a4.183 4.183 0 0 1 .558 4.528Zm1.486-120.85-26.88 26.88c-3.294 3.311-8.937.963-8.937-3.7v-74.778c0-5.389 7.164-7.248 9.799-2.551l26.88 47.898a5.218 5.218 0 0 1-.862 6.251Z" />
            </g>
          </g>
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" style={{ stopColor: "rgba(27, 85, 98, 1)", stopOpacity: 1 }} />
              <stop
                offset="100%"
                style={{ stopColor: "rgba(5, 190, 179, 0.75)", stopOpacity: 1 }}
              />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="mt-20 flex justify-center">
        <a
          href="https://managely.app/yourls/nob"
          target="_blank"
          rel="noopener noreferrer"
          className="px-8 py-4 rounded-md font-semibold tracking-wider text-white transition-all duration-300 animate-gradient"
          style={{
            background: "linear-gradient(125deg, #1b5562, #05beb3, #1b5562)",
            backgroundSize: "200% 200%",
            animation: "gradientMove 6s ease infinite",
          }}
        >
          {t("home.mobile-app-cta")}
        </a>
        <style>
          {`
      @keyframes gradientMove {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }
    `}
        </style>
      </div>
      <div className="mt-12 lg:hidden space-y-4">
        <div className="font-bold">
          <a
            target="_blank"
            rel="noreferrer"
            className="hover:underline"
            href="https://maps.app.goo.gl/M7hb332Gd977PTdS7"
          >
            CORSO VITTORIO EMANUELE II <br></br>218/A - TORINO 10138
          </a>
        </div>
        <div>{t("home.metro")}</div>
        <div className="font-bold">
          <a href="tel:+390110567285" className="hover:underline">
            011.056.7285
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home;
